import { AuthResendVerificationEmailAction, resendVerificationEmail } from "auth/modules/actions";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { State } from "redux/state";
import { Omit } from "utils/Types";
import { VerificationPage, VerificationPageProps } from "../components/VerificationPage";

type DispatchProps = Pick<VerificationPageProps, "resendVerificationEmail">;
type StateProps = Pick<VerificationPageProps, "profile">;
type OwnProps = Omit<VerificationPageProps, keyof (DispatchProps & StateProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch: ThunkDispatch<State, undefined, AuthResendVerificationEmailAction>) => {
    return {
        resendVerificationEmail() {
            dispatch(resendVerificationEmail());
        }
    };
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    profile: (state.auth) ? state.auth.profile : undefined
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VerificationPage);
